export default __webpack_public_path__ + "assets/images/thomas_3kS1-.jpg";